import script from "./yc-code.vue?vue&type=script&setup=true&lang=ts"
export * from "./yc-code.vue?vue&type=script&setup=true&lang=ts"

import "./yc-code.vue?vue&type=style&index=0&id=2ad91dba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad91dba"]])

export default __exports__